import {useMemo} from 'react'

import type {AddressPin} from '../../../api/address'
import {routeDestinationPrefixName, routeSourceName} from '../../../lib/fieldNames'

/**
 * Возвращает отсортированный (от точки отправления до точки прибытия) массив с адресами маршрута
 * @param routeValue Текущее значение всех точек маршрута.
 */
export const useAddresses = (routeValue: Record<string, {address: AddressPin}>) =>
  useMemo<AddressPin[]>(
    () =>
      Object.keys(routeValue)
        // В роут складывается ещё и точка возврата, поэтому здесь выпиливаем её
        .filter(key => key === routeSourceName || key.includes(routeDestinationPrefixName))
        .sort((a, b) => {
          // 'source' всегда должен быть первым
          if (a === routeSourceName) {
            return -1
          }

          // 'source' всегда должен быть первым
          if (b === routeSourceName) {
            return 1
          }

          // Извлечение числовой части из строки вида 'destination_*'
          const numA = parseInt(a.split('_')[1], 10)
          const numB = parseInt(b.split('_')[1], 10)

          // Сравнение числовых частей
          return numA - numB
        })
        .map(key => routeValue[key]?.address)
        .filter(Boolean),
    [routeValue],
  )
